import dynamic from "next/dynamic";

const ModalContainer = dynamic(() => import("./ModalContainer"), {
  ssr: false,
});

export default ModalContainer;
